import React, { FunctionComponent, useState } from 'react'
import ReactDOM from 'react-dom'
import {
  Button,
  FieldValue,
  InputCharLimit,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  TextAreaInput,
} from '@lightspeed/design-system-react'
import { useT, T } from '@transifex/react'
import { useAppDispatch } from '../../../../state/hooks'
import { setSaleNote } from '../../../../state/slices/currentSale/currentSaleSlice'

const NOTE_MAX_CHARS = 2000
const NOTE_THRESHOLD = 50

interface Props {
  initialNote: string
  onClose: () => void
  onParkSale: () => Promise<void>
}

export const AddNoteModal: FunctionComponent<Props> = ({
  initialNote,
  onClose,
  onParkSale,
}) => {
  const t = useT()
  const [note, setNote] = useState(initialNote)
  const dispatch = useAppDispatch()

  const handleParkSale = async () => {
    // Save the note to the sale
    dispatch(setSaleNote(note))

    await onParkSale()
    onClose()
  }

  const noteTooLong = note.length > NOTE_MAX_CHARS

  return ReactDOM.createPortal(
    <Modal size="small" dismissable onClose={onClose}>
      <ModalHeader>
        <T _str="Park this sale with a note" _context="Park sale modal title" />
      </ModalHeader>
      <ModalContent>
        <p className="vd-p">
          <T
            _str="Add a note so the next person who continues this sale can identify it."
            _context="Park sale modal description"
          />
        </p>
        <FieldValue>
          <TextAreaInput
            name="note"
            value={note}
            onChange={e => setNote(e.target.value)}
            autoFocus
            placeholder={t('Enter a note', {
              _context: 'Placeholder',
            })}
            hasError={noteTooLong}
            rows={1}
          />
          <InputCharLimit
            limit={NOTE_MAX_CHARS}
            value={note}
            threshold={NOTE_THRESHOLD}
          />
        </FieldValue>
      </ModalContent>
      <ModalActions>
        <Button
          type="button"
          variant="go"
          disabled={noteTooLong}
          onClick={handleParkSale}
        >
          <T _str="Park sale" />
        </Button>
      </ModalActions>
    </Modal>,
    document.body
  )
}
